import React from "react";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../context/AppContext";
import { useState, useContext } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import Cookies from 'js-cookie';

export default function UserProfile() {
  const [modalOpen, setModalOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const { signOut, siteKey } = useContext(AppContext);
  const [user, setUser] = useState(JSON.parse(Cookies.get("user")));
  const [ErrorMsg, setErrorMsg] = useState("");
  const [captchaValue, setcaptchaValue] = useState(null);
  const [SuccessMsg, setSuccessMsg] = useState("");

  const handleChange = (e) => {
    setUser({ ...updatedUser, [e.target.name]: e.target.value });
  };
  const [Open, setOpen] = useState(true);
  const handleEditClick = () => {
    setIsEditMode(true);
  };
  const handlebackClick = () => {
    setIsEditMode(false);
  };

  // fetch user data
  const fetchUserData = async () => {
    try {
      const token = Cookies.get("token");
      const user = JSON.parse(Cookies.get("user"));
      const userId = user._id;
      const response = await fetch(
        `${process.env.REACT_APP_ADDRESS}/users/getOne/${userId}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.ok) {
        const fetcheduser = await response.json();
        return fetcheduser;
      } else {
        const data = await response.json();
        throw new Error(data.error);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
      setErrorMsg("Error fetching user data: " + error.message);
    }
  };

  // Delete user :
  const handleDeleteUser = async (e) => {
    e.preventDefault();
    try {
      const token = Cookies.get("token");
      const user = JSON.parse(Cookies.get("user"));

      const url = `${process.env.REACT_APP_ADDRESS}/users/delete/${user._id}`;
      const response = await fetch(url, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      if (response.ok) {
        console.log("User disabled successfully");
        handleSignout();
      } else {
        const data = await response.json();
        throw new Error(data.error);
      }
    } catch (error) {
      console.error("Error deleting User:", error);
    }
  };

  const handleSignout = () => {
    navigate("/signin", { replace: true });
    signOut();
  };

  const updatedUser = {
    firstName: user.firstName,
    lastName: user.lastName,
    email: user.email,
    StreetAddress: user.StreetAddress,
    password: user.password,
  };

  //PUT USER
  const updateUser = async () => {
    try {
      const token = Cookies.get("token");
      const user = JSON.parse(Cookies.get("user"));
      const url = `${process.env.REACT_APP_ADDRESS}/users/updateUser/${user._id}`;

      const response = await fetch(url, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(updatedUser),
      });

      if (response.status === 200) {
        console.log("User updated successfully");
        setUser(updatedUser);
        console.log(updatedUser);
        setIsEditMode(false);
        fetchUserData();
      } else {
        const data = await response.json();
        throw new Error(data.error);
      }
    } catch (error) {
      console.error("Error updating User:", error);
    }
  };

  const navigate = useNavigate();

  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };

  // Function to handle initiating password change process
  const handleInitiatePasswordChange = () => {
    setShowPasswordChangeForm(true);
    setOpen(false);
  };

  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [showPasswordChangeForm, setShowPasswordChangeForm] = useState(false);

  const handleVerifyOldPassword = async () => {
    try {
      if (!oldPassword) {
        setErrorMsg("Please enter the old password.");
        return false;
      }

      const token = Cookies.get("token");
      const user = JSON.parse(Cookies.get("user"));
      if (!user || !user._id) {
        throw new Error("User information is not available.");
      }

      const response = await fetch(
        `${process.env.REACT_APP_ADDRESS}/users/verifyPassword/${user._id}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ oldPassword }),
        }
      );

      if (response.ok) {
        console.log("alright");
        return true;
      } else {
        const data = await response.json();
        throw new Error(data.error);
      }
    } catch (error) {
      console.error("Error verifying old password:", error);
      setErrorMsg("Error verifying old password: " + error.message);
      return false;
    }
  };

  const handleUpdatePassword = async () => {
    try {
      const validationError = validatePassword(newPassword);
      if (validationError) {
        setErrorMsg(validationError);
        return;
      }

      const token = Cookies.get("token");
      const user = JSON.parse(Cookies.get("user"));
      if (!user || !user._id) {
        throw new Error("User information is not available.");
      }
      console.log(user._id);
      const response = await fetch(
        `${process.env.REACT_APP_ADDRESS}/users/passwordChange/${user._id}`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ newPassword }),
        }
      );

      if (response.ok) {
        console.log("alriche");
        setSuccessMsg("Password updated successfully.");
        // Fetch the updated user data
        const fetcheduser = await fetchUserData();

        if (fetcheduser) {
          // Update the user data in the session storage and state
          Cookies.set("user", JSON.stringify(fetcheduser));
          setUser(fetcheduser);
          setOldPassword("");
          setNewPassword("");
          setShowPasswordChangeForm(false);
        }
      } else {
        const data = await response.json();
        throw new Error(data.error);
      }
    } catch (error) {
      console.error("Error updating password:", error);
      setErrorMsg("Error updating password: " + error.message);
    }
  };

  const handleSubmitForm = async (e) => {
    e.preventDefault();
    const isOldPasswordVerified = await handleVerifyOldPassword();
    if (isOldPasswordVerified) {
      await handleUpdatePassword();
      setIsEditMode(!true);
    }
  };

  const validatePassword = (password) => {
    const minLength = 8;
    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    const hasNumber = /[0-9]/.test(password);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

    if (password.length < minLength) {
      return "Password must be at least 8 characters long.";
    }
    if (!hasUpperCase) {
      return "Password must contain at least one uppercase letter.";
    }
    if (!hasLowerCase) {
      return "Password must contain at least one lowercase letter.";
    }
    if (!hasNumber) {
      return "Password must contain at least one number.";
    }
    if (!hasSpecialChar) {
      return "Password must contain at least one special character.";
    }
    return "";
  };

  return (
    <form>
      <div className="space-y-12 sm:space-y-16">
        <div>
          <h1 className="text-2xl font-semibold leading-7 text-gray-900 pb-4">
            Profile
          </h1>
          <h2 className="text-base font-semibold leading-7 text-gray-900">
            Personal Information
          </h2>
          {ErrorMsg && <div className="text-red-500 text-sm">{ErrorMsg}</div>}
          {SuccessMsg && (
            <div className="text-green-500 text-sm">{SuccessMsg}</div>
          )}

          <div className="mt-10 space-y-8 border-b border-gray-900/10 pb-12 sm:space-y-0 sm:divide-y sm:divide-gray-900/10 sm:border-t sm:pb-0">
            <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6">
              <label className="block text-sm font-medium leading-6 text-gray-900 sm:pt-1.5">
                First name
              </label>
              <div className="mt-2 sm:col-span-2 sm:mt-0">
                {isEditMode ? (
                  <input
                    type="text"
                    name="firstName"
                    id="firstName"
                    autoComplete="given-name"
                    value={user.firstName}
                    onChange={handleChange}
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-pink-600 sm:max-w-xs sm:text-sm sm:leading-6"
                  />
                ) : (
                  <p> {user.firstName}</p>
                )}
              </div>
            </div>

            <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6">
              <label className="block text-sm font-medium leading-6 text-gray-900 sm:pt-1.5">
                Last name
              </label>
              <div className="mt-2 sm:col-span-2 sm:mt-0">
                {isEditMode ? (
                  <input
                    type="text"
                    name="lastName"
                    id="lastName"
                    autoComplete="family-name"
                    value={user.lastName}
                    onChange={handleChange}
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-pink-600 sm:max-w-xs sm:text-sm sm:leading-6 "
                  />
                ) : (
                  <p> {user.lastName}</p>
                )}
              </div>
            </div>

            <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6">
              <label className="block text-sm font-medium leading-6 text-gray-900 sm:pt-1.5">
                Email address
              </label>
              <div className="mt-2 sm:col-span-2 sm:mt-0">
                {isEditMode ? (
                  <input
                    name="email"
                    id="email"
                    autoComplete="email"
                    value={user.email}
                    onChange={handleChange}
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-pink-600 sm:max-w-md sm:text-sm sm:leading-6"
                  />
                ) : (
                  <p> {user.email}</p>
                )}
              </div>
            </div>
            <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6">
              <label className="block text-sm font-medium leading-6 text-gray-900 sm:pt-1.5">
                Street-Address
              </label>
              <div className="mt-2 sm:col-span-2 sm:mt-0">
                {isEditMode ? (
                  <input
                    name="StreetAddress"
                    id="StreetAddress"
                    autoComplete="StreetAddress"
                    value={user.StreetAddress}
                    onChange={handleChange}
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-pink-600 sm:max-w-md sm:text-sm sm:leading-6"
                  />
                ) : (
                  <p> {user.StreetAddress}</p>
                )}
              </div>
            </div>
            <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6">
              <label className="block text-sm font-medium leading-6 text-gray-900 sm:pt-1.5">
                Password
              </label>
              <div className="mt-2 sm:col-span-2 sm:mt-0">
                {isEditMode && Open ? (
                  <>
                    <input
                      name="password"
                      id="password"
                      autoComplete="address-level2"
                      value=""
                      onChange={handleChange}
                      className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-pink-600 sm:max-w-xs sm:text-sm sm:leading-6"
                    />
                    <button
                      type="button"
                      onClick={handleInitiatePasswordChange}
                      className="mt-2 sm:mt-0 text-sm font-semibold leading-6 text-pink-600 hover:text-gray-700 focus-visible:outline focus-visible:ring focus-visible:ring-pink-600"
                    >
                      Change Password
                    </button>
                  </>
                ) : (
                  <p>******************</p>
                )}
              </div>
            </div>
            {/* Password change form */}
            {showPasswordChangeForm && (
              <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6">
                <label className="block text-sm font-medium leading-6 text-gray-900 sm:pt-1.5">
                  Old Password
                </label>
                <div className="mt-2 sm:col-span-2 sm:mt-0">
                  <input
                    type="password"
                    name="oldPassword"
                    value={oldPassword}
                    onChange={(e) => setOldPassword(e.target.value)}
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-pink-600 sm:max-w-xs sm:text-sm sm:leading-6"
                  />
                </div>
                <label className="block text-sm font-medium leading-6 text-gray-900 sm:pt-1.5">
                  New Password
                </label>
                <div className="mt-2 sm:col-span-2 sm:mt-0">
                  <input
                    type="password"
                    name="newPassword"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-pink-600 sm:max-w-xs sm:text-sm sm:leading-6"
                  />
                </div>
                <div className="sm:col-start-2 sm:mt-4">
                  <button
                   disabled={!captchaValue}
                    onClick={handleSubmitForm}
                    className="inline-flex justify-center rounded-md bg-pink-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-pink-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-pink-600"
                  >
                    Save Password
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="mt-6 flex items-center justify-end gap-x-6">
        {isEditMode ? (
          <>
            <button
              type="button"
              className="text-sm font-semibold leading-6 text-gray-900"
              onClick={handlebackClick}
            >
              Cancel
            </button>
            <button
              disabled={!captchaValue}
              type="button"
              onClick={updateUser}
              className="inline-flex justify-center rounded-md bg-pink-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-pink-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-pink-600"
            >
              Save
            </button>
            <button
              disabled={!captchaValue}
              onClick={toggleModal}
              className="inline-flex justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
              type="button"
            >
              Delete
            </button>
            <div>
              <ReCAPTCHA
                sitekey={siteKey}
                onChange={(val) => setcaptchaValue(val)}
              />
            </div>
            {modalOpen && (
              <div className="fixed top-0 right-0 left-0 z-50 flex justify-center items-center w-full md:inset-0 h-full bg-black bg-opacity-50">
                <div className="relative p-4 w-full max-w-md">
                  <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
                    <button
                      onClick={toggleModal}
                      type="button"
                      className="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                    >
                      <svg
                        className="w-3 h-3"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 14 14"
                      >
                        <path
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                        />
                      </svg>
                      <span className="sr-only">Close modal</span>
                    </button>
                    <div className="p-4 md:p-5 text-center">
                      <svg
                        className="mx-auto mb-4 text-gray-400 w-12 h-12 dark:text-gray-200"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 20 20"
                      >
                        <path
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M10 11V6m0 8h.01M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                        />
                      </svg>
                      <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
                        Are you sure you want to delete this Account?
                      </h3>
                      <button
                        onClick={(e) => {
                          handleDeleteUser(e);
                        }}
                        className="text-white bg-red-600 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 dark:focus:ring-red-800 font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center"
                      >
                        Yes, Im sure
                      </button>
                      <button
                        onClick={toggleModal}
                        className="py-2.5 px-5 ms-3 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700"
                      >
                        No, cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </>
        ) : (
          <button
            onClick={handleEditClick}
            className="inline-flex justify-center rounded-md bg-pink-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-pink-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-pink-600"
          >
            Edit
          </button>
        )}
      </div>
    </form>
  );
}
